import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import LoginPage from '../pages/login/page';
import NewRequestPage from '../pages/new-request/page';
import ReplaceRequestPage from '../pages/replace-request/page';
import PickupRequestPage from '../pages/pickup-request/page';
import RequestsPage from '../pages/requests/page';
import ProfilePage from '../pages/profile/page';
import NotificationsPage from '../pages/notifications/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/new-request',
    element: <NewRequestPage />
  },
  {
    path: '/replace-request',
    element: <ReplaceRequestPage />
  },
  {
    path: '/pickup-request',
    element: <PickupRequestPage />
  },
  {
    path: '/requests',
    element: <RequestsPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/notifications',
    element: <NotificationsPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;